import config from '../../../../../config';
import {authFetch, checkStatus} from '../../../../utils/http';
import {
  convertNetworkInvitationsFromAPI,
  convertNetworkInvitationsToAPI,
  convertSuggestionsFromAPI
} from '../../helper';

import {getPendingOrRejectedInvitations} from './utils';

export const INVITATION_API = `${config.enrollmentApi}/api/v1/network-invitations`;

function inviteSubcontractors(organisationId, invitations) {
  return authFetch(`${INVITATION_API}/${organisationId}/subcontractors`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(convertNetworkInvitationsToAPI(invitations))
  })
    .then(checkStatus);
}

function inviteClients(organisationId, invitations) {
  return authFetch(`${INVITATION_API}/${organisationId}/clients`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(convertNetworkInvitationsToAPI(invitations))
  })
    .then(checkStatus);
}

function cancelPendingInvitation(invitationId) {
  return authFetch(`${INVITATION_API}/${invitationId}`, {
    method: 'DELETE'
  })
    .then(checkStatus);
}

function resendInvitation(invitationId, reason) {
  return authFetch(`${INVITATION_API}/${invitationId}/resend`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(reason)
  })
    .then(checkStatus)
    .then(response => response.json());
}

function searchInvitations(data) {
  return authFetch(`${INVITATION_API}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(data)
  })
    .then(checkStatus)
    .then(response => response.json())
    .then(response => convertNetworkInvitationsFromAPI(response));
}

function getInvitationsSentToSubcontractor(invitingOrganisationId) {
  // using invitingClientId key because we're the client of our subcontractors
  return getPendingOrRejectedInvitations({invitingClientId: invitingOrganisationId});
}

function getInvitationsSentToClient(invitingOrganisationId) {
  // using invitingSubcontractorId key because we're the subcontractor of our clients
  return getPendingOrRejectedInvitations({invitingSubcontractorId: invitingOrganisationId});
}

function getSuggestions(subcontractorId) {
  return authFetch(`${INVITATION_API}/suggestions?subcontractorId=${subcontractorId}`, {
    method: 'GET'
  })
    .then(response => checkStatus(response, false))
    .then(response => response.json())
    .then(response => convertSuggestionsFromAPI(response));
}

function acceptSuggestion(organisationId, invitationId) {
  return authFetch(`${INVITATION_API}/suggestions/accept?invitationId=${invitationId}&subcontractorId=${organisationId}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    }
  })
    .then(checkStatus);
}

function rejectSuggestion(organisationId, invitationId, rejectionReason) {
  return authFetch(`${INVITATION_API}/suggestions/reject`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      invitationId,
      subcontractorId: organisationId,
      status: 'REJECTED',
      rejectionReason
    })
  })
    .then(checkStatus);
}

export default {
  inviteSubcontractors,
  inviteClients,
  cancelPendingInvitation,
  resendInvitation,
  searchInvitations,
  getInvitationsSentToClient,
  getInvitationsSentToSubcontractor,
  getSuggestions,
  acceptSuggestion,
  rejectSuggestion
};
